import React, {Dispatch, useMemo} from "react"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import useWindowSize from "../../../../../hooks/useWindowSize"
import CustomSelect from "../../../../generic/dataEntry/CustomSelect/CustomSelect"
import {CustomSelectOption} from "../../../../../models"
import {setOrderFilters} from "../../../../../store/actions/orderActions"
import CustomRangePicker from "../../../../generic/dataEntry/CustomRangePicker"
import Modal from "../../../modals/Modal"
import classes from "./OrderFilter.module.scss"

interface IOrderFilterProps {
  toggleModal: Dispatch<any>
  showModal?: boolean
}

function OrderFilter({toggleModal, showModal}: IOrderFilterProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()
  const {paymentTypes, filters} = useAppSelector(state => state.order)
  const brigades = useAppSelector(state => state.brigade.list)
  const managers = useAppSelector(state => state.manager.list)

  const paymentOptions = useMemo(() => {
    const list = paymentTypes.map(type => (
      {
        label: type.name,
        value: Number(type.id)
      }
    ))
    list.unshift({label: "Не выбран", value: 0})
    return list
  }, [paymentTypes])

  const brigadeOptions = useMemo(() => {
    const list = brigades.map(brigade => (
      {
        label: brigade.brigade,
        value: brigade.id
      }
    ))
    list.unshift({label: "Не выбрана", value: 0})
    return list
  }, [brigades])

  const managerOptions = useMemo(() => {
    const list = managers.map(manager => (
      {
        label: manager.fio,
        value: manager.id
      }
    ))
    list.unshift({label: "Не выбран", value: 0})
    return list
  }, [managers])

  const periodChangeHandler = (dates: any) => {
    if (dates) {
      dispatch(setOrderFilters({...filters, request_date_from: dates[0], request_date_to: dates[1]}))
    } else {
      dispatch(setOrderFilters({...filters, request_date_from: "", request_date_to: ""}))
    }
  }

  const modalFilter = showModal &&
    <Modal
      close={() => toggleModal(false)}
      title={"Фильтры"}
    >
      <div
        className={classes.modal_form}
      >
        <div className={classes.modal_form_field}>
          <CustomRangePicker
            label={"Период"}
            curDates={(filters.request_date_from && filters.request_date_to) ? [filters.request_date_from, filters.request_date_to] : undefined}
            onChangeDate={(dates: string) => {
              periodChangeHandler(dates)
            }}
          />
        </div>
        <div className={classes.modal_form_field}>
          <CustomSelect
            placeholder={"Не выбран"}
            label={"Способ оплаты"}
            options={paymentOptions}
            value={paymentOptions.find(item => item.value === filters?.payment_type_id)}
            onChange={(option: CustomSelectOption) => {
              dispatch(setOrderFilters({...filters, payment_type_id: Number(option.value)}))
            }}
          />
        </div>
        <div className={classes.modal_form_field}>
          <CustomSelect
            placeholder={"Не выбрана"}
            label={"Бригада"}
            options={brigadeOptions}
            value={brigadeOptions.find(item => item.value === filters?.brigade_id)}
            onChange={(option: CustomSelectOption) => {
              dispatch(setOrderFilters({...filters, brigade_id: Number(option.value)}))
            }}
          />
        </div>
        <div className={classes.modal_form_field}>
          <CustomSelect
            placeholder={"Не выбран"}
            label={"Менеджер"}
            options={managerOptions}
            value={managerOptions.find(item => item.value === filters?.manager_id)}
            onChange={(option: CustomSelectOption) => {
              dispatch(setOrderFilters({...filters, manager_id: Number(option.value)}))
            }}
          />
        </div>
      </div>
    </Modal>

  return (
    <>
      {windowSize.width >= 992 &&
        <div className={classes.wrap}>
          <div className={[classes.field, classes.field_period].join(" ")}>
            <CustomRangePicker
              label={"Период"}
              curDates={(filters.request_date_from && filters.request_date_to) ? [filters.request_date_from, filters.request_date_to] : undefined}
              onChangeDate={(dates: string) => {
                periodChangeHandler(dates)
              }}
            />
          </div>
          <div className={classes.field}>
            <CustomSelect
              placeholder={"Не выбран"}
              label={"Способ оплаты"}
              options={paymentOptions}
              value={paymentOptions.find(item => item.value === filters?.payment_type_id)}
              onChange={(option: CustomSelectOption) => {
                dispatch(setOrderFilters({...filters, payment_type_id: Number(option.value)}))
              }}
            />
          </div>
          <div className={classes.field}>
            <CustomSelect
              placeholder={"Не выбрана"}
              label={"Бригада"}
              options={brigadeOptions}
              value={brigadeOptions.find(item => item.value === filters?.brigade_id)}
              onChange={(option: CustomSelectOption) => {
                dispatch(setOrderFilters({...filters, brigade_id: Number(option.value)}))
              }}
            />
          </div>
          <div className={classes.field}>
            <CustomSelect
              placeholder={"Не выбран"}
              label={"Менеджер"}
              options={managerOptions}
              value={managerOptions.find(item => item.value === filters?.manager_id)}
              onChange={(option: CustomSelectOption) => {
                dispatch(setOrderFilters({...filters, manager_id: Number(option.value)}))
              }}
            />
          </div>
        </div>
      }
      {modalFilter}
    </>
  )
}

export default OrderFilter